import { z } from 'zod';

import { uuidValidator } from '../../validators';

export const AddWordToGroupSchema = z.object({
  wordIds: z
    .array(uuidValidator)
    .min(1, 'At least one word ID must be provided'),
});

export type IAddWordToGroupDto = z.infer<typeof AddWordToGroupSchema>;
